"use strict";
/**
 * Moderation `contributions` canonical template — single source of truth for the
 * `moderation-contributions` OpenSearch index family (registered by the setup lambda).
 *
 * Moderation families are REGISTRAR-ONLY (setup lambda registers; moderation-history
 * reads by alias), have NO search-document interface, and are NOT read by application
 * search queries — so they expose a TEMPLATE BUILDER ONLY (no `*_FIELDS` constants, no
 * interface). Field types ported VERBATIM from the setup lambda's inline
 * `moderation-contributions` block. No analyzers (plain mappings), so `settings.analysis`
 * is OMITTED.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildModerationContributionsTemplate = buildModerationContributionsTemplate;
/** Build the composable OpenSearch index-template body for the `moderation-contributions` family. */
function buildModerationContributionsTemplate(opts) {
    return {
        index_patterns: [opts.pattern],
        template: {
            settings: {
                number_of_shards: opts.shards ?? 1,
                number_of_replicas: opts.replicas ?? 0,
                refresh_interval: opts.refresh ?? '5s',
            },
            mappings: {
                dynamic: true,
                properties: {
                    contribution_id: { type: 'keyword' },
                    content_type: { type: 'keyword' },
                    contributor_id: { type: 'keyword' },
                    contributor_screen_name: { type: 'keyword' },
                    status: { type: 'keyword' },
                    outcome: { type: 'keyword' },
                    resolved_by: { type: 'keyword' },
                    created_at: { type: 'date' },
                    resolved_at: { type: 'date' },
                    name: { type: 'text' },
                    brand: { type: 'keyword' },
                    category: { type: 'keyword' },
                },
            },
        },
        priority: 100,
        _meta: { managed_by: 'fpw', purpose: 'moderation-contributions' },
    };
}
